export default __webpack_public_path__ + "static/media/picture1.7294f3c0.png";